import { ThemeProvider } from "styled-components";
import { AuthProvider } from "./Contexts/AuthContext";
import AppRoutes from "./Routers/AppRouter";
import GlobalStyles from "./StyledGlobal";
import { samdocTheme } from "./Themes/ThemeDefault";

function App() {
  return (
    <ThemeProvider theme={samdocTheme}>
      <AuthProvider>
        <GlobalStyles />
        <AppRoutes />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
